import { Box, HStack, Text, useControllableState } from "@chakra-ui/react"
import Button from "@pathwright/ui/src/components/button/Button"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import SearchInput from "@pathwright/ui/src/components/form/form-text-input/SearchInput"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Screensize from "@pathwright/ui/src/components/ui/Screensize"
import capitalize from "lodash/capitalize"
import { MEMBERSHIP_FILTERS } from "./constants"

function MembershipSearch({
  value: valueProp,
  searching,
  membershipFilter,
  onSearch,
  onFilter
}) {
  const [value, setValue] = useControllableState({
    defaultValue: "",
    value: valueProp,
    onChange: onSearch
  })

  const handleChange = (value) => {
    setValue(value)
  }

  const handleClear = () => {
    handleChange("")
  }

  const handleFilter = (membershipFilter) => () => {
    onFilter(membershipFilter)
  }

  return (
    <Screensize.Consumer>
      {(screensize) => (
        <HStack p={2}>
          <Box flexGrow={1}>
            <SearchInput
              emphasis="tertiary"
              placeholder="Search..."
              onChange={handleChange}
              onClear={handleClear}
              value={value}
              autoFocus={screensize !== "sm"}
              searching={searching}
            />
          </Box>
          <DropdownTrigger
            alignment="left"
            renderDropdown={() => (
              <DropdownMenu closeOnClick>
                {Object.keys(MEMBERSHIP_FILTERS).map((label, index) => (
                  <DropdownItem
                    key={index}
                    label={capitalize(label)}
                    onClick={handleFilter(label)}
                  />
                ))}
              </DropdownMenu>
            )}
          >
            <Button styleType="secondary">
              <HStack gap={1}>
                {screensize !== "sm" && <Text as="span">Show</Text>}
                <strong>{capitalize(membershipFilter)}</strong>
                <Pathicon icon="chevron-down" />
              </HStack>
            </Button>
          </DropdownTrigger>
          <Button styleType="secondary" to="/community/members/invite/">
            {screensize === "sm" ? "Invite" : "Invite members"}
          </Button>
        </HStack>
      )}
    </Screensize.Consumer>
  )
}

MembershipSearch.displayName = "MembershipSearch"

export default MembershipSearch
